import {
    GenericTableDateFilterFormat,
    GenericTableFilterView,
    GenericTableFilterType,
} from 'inside-fifa/api/generic-tables/dto';
import { FilterOption } from '../filter/dto';
import { FormattedMessage } from 'react-intl';

export const dateFormats: FilterOption<GenericTableDateFilterFormat>[] = [
    {
        key: GenericTableDateFilterFormat.FullDate,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.date-formats.FullDate`} />,
    },
    {
        key: GenericTableDateFilterFormat.WithoutYear,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.date-formats.WithoutYear`} />,
    },
    {
        key: GenericTableDateFilterFormat.YearOnly,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.date-formats.YearOnly`} />,
    },
];

export const viewFormats: FilterOption<GenericTableFilterView>[] = [
    {
        key: GenericTableFilterView.Default,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.view-formats.Default`} />,
    },
    {
        key: GenericTableFilterView.ButtonGroup,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.view-formats.ButtonGroup`} />,
    },
];

export const filterTypes: FilterOption<GenericTableFilterType>[] = [
    {
        key: GenericTableFilterType.SingleSelectFilter,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.data-column.SingleSelectFilter`} />,
    },
    {
        key: GenericTableFilterType.MultipleSelectFilter,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.data-column.MultipleSelectFilter`} />,
    },
    {
        key: GenericTableFilterType.DateFilter,
        placeholder: <FormattedMessage id={`inside-fifa.generic-tables.filters.data-column.DateFilter`} />,
    },
];
